// extracted by mini-css-extract-plugin
export default {"inputLoaderIcon":"-incv","rotatingfunction":"-S9ec","skeleton-progress":"WfEfk"};